import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SecondaryButton } from 'jl-design-system/elements/button/Button';

import { getDisplayName } from '~/utils';

import styles from './SelectableListItem.scss';

export const selectableListItem = (Item) =>
  class extends PureComponent {
    static displayName = `Selectable(${getDisplayName(Item)})`;

    static propTypes = {
      handleSelect: PropTypes.func,
      dataTest: PropTypes.string,
      bookingOption: PropTypes.shape({}),
      CTAComponent: PropTypes.func,
      CTAClassName: PropTypes.string,
    };

    static defaultProps = {
      handleSelect: undefined,
      dataTest: '',
      bookingOption: {},
      CTAComponent: ({ handleSelect, className }) => (
        <SecondaryButton inline className={className} onClick={handleSelect}>
          Select and continue
        </SecondaryButton>
      ),
      CTAClassName: undefined,
    };

    render() {
      const { handleSelect, dataTest, CTAComponent, CTAClassName, ...props } = this.props;

      return (
        <article className={styles.SelectableListItem} data-testid={dataTest}>
          <div className={styles.Content}>
            <Item {...props} />
          </div>
          <CTAComponent
            className={classnames(styles.Button, CTAClassName)}
            handleSelect={handleSelect}
            {...props}
          />
        </article>
      );
    }
  };
